import { useState, useEffect } from 'react';
import { useLanguage } from '../../../../../contexts/LanguageContext';
import { useGetDealerAddressUsersQuery, useGetLookUpDropdownListQuery } from '../../../../../api';

export const useDealerAddressUsersData = ({ dealerAddress, pageSize = 10, enabled = true }) => {
    const { th, getCurrentLanguageId } = useLanguage();
    const [pageNumber, setPageNumber] = useState(1);

    const dealerAddressId = dealerAddress ? dealerAddress.id : null;

    const { data: usageTypeOptions = [] } = useGetLookUpDropdownListQuery({
        GroupCode: 'XXBOS_USAGE_TYPE',
        LanguageId: getCurrentLanguageId()
    });

    const { data, isLoading, refetch } = useGetDealerAddressUsersQuery({ AddressId: dealerAddressId, PageNumber: pageNumber, PageSize: pageSize }, { skip: !enabled });

    const usageTypeBodyTemplate = (rowData) => {
        const found = usageTypeOptions.find((option) => Number(option.code) === Number(rowData.usageType));
        return found?.translatedText || rowData.usageType;
    };

    const statusBodyTemplate = (rowData) => {
        return <span className={`p-badge p-badge-${rowData.isActive === 1 ? 'success' : 'danger'}`}>{rowData.isActive === 1 ? th('userAccounts.active') : th('userAccounts.inactive')}</span>;
    };

    const columns = [
        { field: 'firstName', header: th('customerAddressBrand.tabs.dealerAddressUsers.columns.firstName') },
        { field: 'lastName', header: th('customerAddressBrand.tabs.dealerAddressUsers.columns.lastName') },
        { field: 'email', header: th('customerAddressBrand.tabs.dealerAddressUsers.columns.email') },
        { field: 'usageType', header: th('customerAddressBrand.tabs.dealerAddressUsers.columns.usageType'), body: usageTypeBodyTemplate },
        { field: 'isActive', header: th('customerAddressBrand.tabs.dealerAddressUsers.columns.isActive'), body: statusBodyTemplate }
    ];

    return {
        data: data?.items || [],
        count: data?.count || 0,
        pageNumber,
        setPageNumber,
        pageSize,
        columns,
        isLoading,
        refetchData: refetch
    };
};
